/**
 * 통계에 사용되는 필드 언어팩
 */
export const statsFieldPack = {
    id: {
        key: 'id',
        title: 'No',
    },
    // [공통] 명칭
    hubName: {
        key: 'hubName',
        title: '허브명',
    },
    distributorName: {
        key: 'distributorName',
        title: '총판명',
    },
    storeName: {
        key: 'storeName',
        title: '상점명',
    },
    date: {
        key: 'date',
        title: '날짜',
    },
    monthly: {
        key: 'monthly',
        title: '해당월',
    },
    allCount: {
        key: 'allCount',
        title: '전체',
    },
    completed: {
        key: 'completed',
        title: '완료',
    },
    ratio: {
        key: 'ratio',
        title: '비율',
    },
    goodsPrice: {
        key: 'goodsPrice',
        title: '상품가격',
    },
    unitPrice: {
        key: 'unitPrice',
        title: '건당단가',
    },
    creditCardCount: {
        key: 'creditCardCount',
        title: '카드건수',
    },
    creditCardPrice: {
        key: 'creditCardPrice',
        title: '카드금액',
    },
    creditCardPercent: {
        key: 'creditCardPercent',
        title: '카드비율',
    },
    total: {
        key: 'total',
        title: '합계',
    },
    // [탭] 상점 일별
    // [탭] 상점 월별
    // [탭] 상점 시간대별
    // [탭] 상점 요일별
    // [탭] 상점 공유상점 통계 참고용
    orderHubCode: {
        key: 'orderHubCode',
        title: '발주허브코드',
    },
    orderHubName: {
        key: 'orderHubName',
        title: '발주허브명',
    },
    storeCode: {
        key: 'storeCode',
        title: '상점코드',
    },
    agencyHubCode: {
        key: 'agencyHubCode',
        title: '수행허브코드',
    },
    agencyHubName: {
        key: 'agencyHubName',
        title: '수행허브명',
    },
    count: {
        key: 'count',
        title: '건수',
    },
    supplyCost: {
        key: 'supplyCost',
        title: '공급가액',
    },
    tax: {
        key: 'tax',
        title: '세액',
    },
    totalDeliveryFee: {
        key: 'totalDeliveryFee',
        title: '배달대행료합계',
    },
    // [탭] 허브 일별, [탭] 허브 월별
    goodsSales: {
        key: 'goodsSales',
        title: '상품매출액',
    },
    goodsSalesAll: {
        key: 'goodsSalesAll',
        title: '전체매출',
    },
    goodsUnitPrice: {
        key: 'goodsUnitPrice',
        title: '상품객단가',
    },
    goodsUnitPriceAll: {
        key: 'goodsUnitPriceAll',
        title: '전체',
    },
    // 사용 안 함. 히스토리 차원에서 기록
    // doneCountPerCategory: {
    //   key: 'doneCountPerCategory',
    //   title: '분류별완료건수',
    // },
    // doneCountPerCategoryAll: {
    //   key: 'doneCountPerCategoryAll',
    //   title: '전체',
    // },
    deliveryFee: {
        key: 'deliveryFee',
        title: '배달대행료',
    },
    deliveryFeeAll: {
        key: 'deliveryFeeAll',
        // title: '전체',
        title: '전체배달대행료',
    },
    deliveryFeeAvg: {
        key: 'deliveryFeeAvg',
        title: '평균',
    },
    completedCount: {
        key: 'completedCount',
        title: '완료건수',
    },
    /** 완료 전체 건수 */
    completedCountAll: {
        key: 'completedCountAll',
        title: '전체',
    },
    /** 완료 현금 건수 */
    completedCountCash: {
        key: 'completedCountCash',
        title: '현금',
    },
    /** 완료 카드 건수 */
    completedCountCard: {
        key: 'completedCountCard',
        title: '카드',
    },
    /** 완료 마일리지 건수 */
    completedCountMileage: {
        key: 'completedCountMileage',
        title: '마일리지',
    },
    /** 완료 크레딧 건수 */
    completedCountCredit: {
        key: 'completedCountCredit',
        title: '외상',
    },
    completedRatio: {
        key: 'completedPercent',
        title: '완료비율',
    },
    completedRatioCash: {
        key: 'completedRatioCash',
        title: '현금',
    },
    completedRatioCard: {
        key: 'completedRatioCard',
        title: '카드',
    },
    completedRatioMileage: {
        key: 'completedRatioMileage',
        title: '마일리지',
    },
    completedRatioCredit: {
        key: 'completedRatioCredit',
        title: '외상',
    },
    cancelCount: {
        key: 'cancelCount',
        title: '취소건수',
    },
    // [탭] 허브 시간대별
    // [탭] 허브 요일별
};
export const hubDailyLocalePack = {
    id: 'No',
    distributorName: '총판명',
    hubName: '허브명',
    date: '일시',
    orderAmount: [
        '상품매출액',
        '전체',
    ],
    orderAmountAverage: [
        '상품객단가',
        '전체',
    ],
    deliveryCharge: [
        '배달대행료',
        '전체',
        '평균',
    ],
    completeCount: [
        '완료건수',
        '전체',
        '현금',
        '카드',
        '마일리지',
        '외상',
    ],
    completedRatio: [
        '완료비율',
        '현금',
        '카드',
        '마일리지',
        '외상',
    ],
    cancelCount: '취소건수',
};
export const hubDailyFieldPack = {
    id: 'id',
    distributorName: 'distributorName',
    hubName: 'hubName',
    date: 'date',
    orderAmount: 'orderAmount',
    orderAmountAverage: 'orderAmountAverage',
    deliveryCharge: 'deliveryCharge',
    deliveryChargeAverage: 'deliveryChargeAverage',
    completeCount: 'completeCount',
    cashCount: 'cashCount',
    cardCount: 'cardCount',
    mileageCount: 'mileageCount',
    laterCount: 'laterCount',
    cashRatio: 'cashRatio',
    cardRatio: 'cardRatio',
    mileageRatio: 'mileageRatio',
    laterRatio: 'laterRatio',
    cancelCount: 'cancelCount',
};
